/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {useTypedSelector} from "helpers/reducers";
import {withRouter} from "react-router";
import {useDispatch} from "useDispatch";
import BookingAction from "store/booking/BookingAction";
import PackageCategoryCard from "pages/Front/Booking/components/PackageCategoryCard";
import {PackageCategory} from "types/enums/PackageCategory";
import {appendQueryParams} from "utils/utility";
import {useHistory} from "react-router-dom";
import {usePackageCategory} from "utils/hooks/usePackageCategory";

const BookingIntroNew = () => {
    const {t} = useTranslation();
    const {categories, packageCategoryCardHandle} = usePackageCategory();

    const history = useHistory();
    const dispatch = useDispatch();
    const hall = useTypedSelector(state => state.hallState.hall);
    const bookingFilter = useTypedSelector(state => state.bookingState.bookingProcess.filter);

    const openPackageCategoryDetail = (categorySlug: PackageCategory) => {
        dispatch(
            BookingAction.setFilter({
                ...bookingFilter,
                category: categorySlug,
            })
        );
        if (
            categorySlug === PackageCategory.General ||
            categorySlug === PackageCategory.Action ||
            categorySlug === PackageCategory.School ||
            categorySlug === PackageCategory.FerienPass
        ) {
            return history.push("/booking/category/detail/" + categorySlug + "?" + appendQueryParams(bookingFilter));
        }

        if (categorySlug === PackageCategory.Event) {
            return history.push("/booking/events/detail/" + "?" + appendQueryParams(bookingFilter));
        }
    };

    useEffect(() => {
        dispatch(BookingAction.setPackage(null));
        // dispatch(BookingAction.clearUpsells());
        dispatch(BookingAction.clearBookingProcess());
        // dispatch(BookingAction.clearAvailableCompetitionItems());
        // dispatch(BookingAction.clearAvailableCreditItems());
    }, []);

    if (!hall) {
        return (
            <div className="flex flex-col w-full items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-1 border-dashed  border-t-arbo-orange border-r-arbo-red mb-4"></div>
                <div className="text-xl font-semibold text-gray-700">{t("Loading please wait")}</div>
            </div>
        );
    }

    return (
        <div className={clsx("BookingPagesInner w-full grid grid-cols-6 gap-8 snap-y snap-mandatory")}>
            {categories
                .filter(item => item.enable)
                .map((category, index) => {
                    return (
                        <PackageCategoryCard
                            key={index}
                            categoryEntity={category}
                            className={"col-span-6"}
                            index={index}
                            showMoreDetail={category.showMoreDetail}
                            onClick={() => packageCategoryCardHandle(category.id)}
                            onDetailClick={() => openPackageCategoryDetail(category.id)}
                        />
                    );
                })}
        </div>
    );
};

export default withRouter(BookingIntroNew);
